import { UserVehicleInfo } from '../../../models/profile-with-vehicles';

export function buildVehicleLabel(preSelectedVehicle: UserVehicleInfo) {
    const VehicleModelAndYear =
        preSelectedVehicle.modelName + ' ' + preSelectedVehicle.modelYear;
    return preSelectedVehicle.nickName
        ? preSelectedVehicle.nickName
        : VehicleModelAndYear;
}
